import VueWrapper from '@/components/core/Vue/vue.wrapper';
import ViewWrapperComponent from '@/components/shared/view-wrapper/view-wrapper.component';
import {TagModel} from '@/sdk';
import {TagApi} from '@/sdk/api-services';
import {Component, Prop, Watch} from 'vue-property-decorator';

@Component({
    components: {
        ViewWrapperComponent,
    },
})
export default class TagDialogComponent extends VueWrapper {
    public $refs!: {
        viewWrapper: ViewWrapperComponent;
    };

    @Prop({
        type: String,
        default: 'tag-dialog',
    })
    public readonly name!: string;

    // @Prop({
    //     type: Boolean,
    //     default: false,
    // })
    // public readonly show!: boolean;

    @Prop({
        type: Object as () => TagModel | null,
        default: null,
    })
    public readonly selectedTag!: TagModel | null;

    @Prop({
        type: String,
        default: 'qr_code',
    })
    public readonly type!: string;

    public tagImageUrl: string | null = null;
    public isLoading: boolean = false;

    public tagApi: TagApi = new TagApi();

    // @Watch('show')
    // public onShowChange(newValue: boolean) {
    //     if (newValue) {
    //         this.open();
    //     } else {
    //         this.close();
    //     }
    // }

    @Watch('selectedTag', {immediate: true})
    public onSelectedTagChange() {
        if (this.selectedTag) {
            this.loadTagImage();
        }
    }

    public mounted() {
        // if (this.show) {
        //     this.open();
        // }
    }

    public get isQrCode() {
        return this.type === 'qr_code';
    }

    public get dialogTitle() {
        const typeMap: {[key: string]: string} = {
            qr_code: 'QR Code',
            barcode: 'Bar Code',
            nfc_tag: 'NFC Tag',
        };
        return typeMap[this.type] || 'Tag Details';
    }

    private async loadTagImage() {
        if (this.isQrCode) {
            this.generateQrCode();
        } else {
            this.generateBarcode();
        }
    }

    private generateQrCode() {
        this.isLoading = true;
        this.tagApi
            .generateQRCode(this.selectedTag?.code || '', 200)
            .then(res => {
                this.tagImageUrl = res;
            })
            .catch(err => {
                this.AlertSrv.show('error', `${err.error.message}`);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    private generateBarcode() {
        this.isLoading = true;
        this.tagApi
            .generateBarcode(this.selectedTag?.code || '', 70)
            .then(res => {
                this.tagImageUrl = res;
            })
            .catch(err => {
                this.AlertSrv.show('error', `${err.error.message}`);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    public downloadTagImage() {
        if (this.tagImageUrl && this.selectedTag?.code) {
            const img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = this.tagImageUrl;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                if (ctx) {
                    canvas.width = img.width;
                    canvas.height = img.height + 70; // Add space for the tag title and code

                    // Set background color to white
                    ctx.fillStyle = 'white';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);

                    ctx.drawImage(img, 0, 0);
                    ctx.font = '20px Arial';
                    ctx.fillStyle = 'black';
                    ctx.textAlign = 'center';
                    ctx.fillText(this.selectedTag!.name, canvas.width / 2, img.height + 30);
                    ctx.fillText(`(${this.selectedTag!.code})`, canvas.width / 2, img.height + 50);

                    const link = document.createElement('a');
                    link.href = canvas.toDataURL('image/png');
                    link.download = `${this.selectedTag!.code}.png`;
                    link.click();

                    link.remove();
                    canvas.remove(); // Remove the canvas to clear resources
                }
            };
        }
    }

    public open() {
        if (this.CoreSrv.isModalOpened(this.name)) {
            this.close();
        }
        this.CoreSrv.OpenModal(this.name);
        this.$emit('opened');
    }

    public close() {
        this.CoreSrv.CloseModal(this.name);
        this.$emit('closed');
        this.$emit('update:show', false);
    }
}
